
export default function About() {
  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Photo */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/1c8837aac8362b62a5f97135f8b0212a.png"
                alt="Dr. Luiz Renato Kreb - Cirurgião Buco-Maxilo-Facial"
                className="w-full h-auto rounded-lg shadow-2xl object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#6B2432] text-white p-6 rounded-lg shadow-xl">
                <div className="text-center">
                  <div className="text-3xl font-bold">15+</div>
                  <div className="text-sm">Anos de Experiência</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-3xl md:text-4xl font-bold text-[#5A5A5A] mb-6">
              Conheça o <strong className="text-[#6B2432]">Dr. Luiz Renato Kreb</strong>
            </h2>
            
            <div className="space-y-6 text-lg text-[#5A5A5A] leading-relaxed">
              <p>
                Com mais de 15 anos de experiência em Cirurgia Buco-Maxilo-Facial, 
                <strong> Dr. Luiz Renato Kreb</strong> é referência em harmonização orofacial 
                e reabilitação oral em Maringá e região.
              </p>
              
              <p>
                Sua trajetória profissional inclui intercâmbio em Madrid, Espanha, 
                onde aperfeiçoou técnicas avançadas em cirurgia maxilofacial, 
                além de 3 pós-graduações especializadas que garantem o mais alto 
                padrão de atendimento aos seus pacientes.
              </p>
              
              <p>
                <strong>Dr. Luiz Renato Kreb</strong> combina expertise técnica com 
                atendimento humanizado, focando sempre nos melhores resultados 
                para cada paciente, especialmente aqueles que buscam reabilitação 
                oral completa e harmonização facial.
              </p>
            </div>

            {/* Credentials */}
            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="text-center p-4 bg-[#F5F5F5] rounded-lg">
                <i className="ri-award-line text-3xl text-[#6B2432] mb-2"></i>
                <div className="font-semibold text-[#5A5A5A]">CRO 25.239</div>
                <div className="text-sm text-[#5A5A5A]">Paraná</div>
              </div>
              <div className="text-center p-4 bg-[#F5F5F5] rounded-lg">
                <i className="ri-global-line text-3xl text-[#6B2432] mb-2"></i>
                <div className="font-semibold text-[#5A5A5A]">Intercâmbio</div>
                <div className="text-sm text-[#5A5A5A]">Madrid</div>
              </div>
              <div className="text-center p-4 bg-[#F5F5F5] rounded-lg">
                <i className="ri-graduation-cap-line text-3xl text-[#6B2432] mb-2"></i>
                <div className="font-semibold text-[#5A5A5A]">3 Pós-Graduações</div>
                <div className="text-sm text-[#5A5A5A]">Especializadas</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
